export class AppLabels {
  public static readonly MAINTENANCE_TYPES: any = [
    { value: 0, label: 'Maintenance PLUS' },
    { value: 1, label: 'Maintenance Premium' },
    { value: 10, label: 'On-request inspection' }
  ];
  public static readonly OPTIMIZATION_TYPES: any = [
    { value: 2, label: 'Process Optimization' },
    { value: 3, label: 'Tooling Audit' }
  ];

  public static readonly REPARATOR_KEYS: any = [
    { value: 0, label: 'reparator.type.mechanical-technician' },
    { value: 1, label: 'reparator.type.electrical-technician' },
    { value: 2, label: 'reparator.type.plant-operator' },
    { value: 3, label: 'reparator.type.instructor' },
    { value: 4, label: 'reparator.type.customer-electrical-technician' },
    { value: 5, label: 'reparator.type.customer-mechanical-technician' },
    { value: 99, label: 'reparator.type.other' }
  ];
}
